export const Types = {
  SAVE_USER: "SAVE_USER",
  VALIDATE_USER: "VALIDATE_USER",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",
  REDIRECT: "REDIRECT",
  LOG_OUT: "LOG_OUT",
  SAVE_COMPANY: "SAVE_COMPANY",
  USER_PROFILE:"USER_PROFILE"
};